import { render, staticRenderFns } from "./NioFormItem.vue?vue&type=template&id=6d081edc&scoped=true&"
import script from "./NioFormItem.vue?vue&type=script&lang=js&"
export * from "./NioFormItem.vue?vue&type=script&lang=js&"
import style0 from "./NioFormItem.vue?vue&type=style&index=0&id=6d081edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d081edc",
  null
  
)

export default component.exports